<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('pipelines.label.reasons') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                        <span class="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                  fill="currentColor" />
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                  fill="currentColor" />
                            </svg>
                        </span>
            </div>
          </div>
          <div class="modal-body">
            <Input
              containerClass="col-12 col-md-12 mt-2 mb-5"
              :name="`${id}-name`"
              type="text"
              :label="$t('pipelines.label.reasons')"
              labelClass="form-label"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="false" size="lg"
              v-model="name"
            />
            <CKEditor id="loose-motif-editor" :label="$t('pipelines.label.motif')" :content="lossMotif" container-class="col-12 col-md-12 mb-2 mt-2"/>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import { ref, defineProps, computed } from "vue";
  import Button from "@/components/Button.vue"
  import CKEditor from "@/components/CKEditor.vue"
  import Input from "@/components/Input.vue";

  const props = defineProps({
    id: {
        type: String,
        required: true
    },
    reason: Object
  })

  const name = computed(() => props.reason?.reason?.name)
  const lossMotif = computed(() => props.reason?.loss_motif)


  function closeModal(){
    $('#'+props.id).modal('toggle')
  }

</script>

<style scoped></style>
